import { createContext } from 'react';
import { UserProfileInfo } from 'api/user';

export const CurrentUserContext = createContext<UserProfileInfo | null>(null);
